import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DrawerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.7778 10.8889H4.22222M19.7778 10.8889C20.3671 10.8889 20.9324 11.123 21.3491 11.5398C21.7659 11.9565 22 12.5217 22 13.1111V19.7778C22 20.3671 21.7659 20.9324 21.3491 21.3491C20.9324 21.7659 20.3671 22 19.7778 22H4.22222C3.63285 22 3.06762 21.7659 2.65087 21.3491C2.23413 20.9324 2 20.3671 2 19.7778V13.1111C2 12.5217 2.23413 11.9565 2.65087 11.5398C3.06762 11.123 3.63285 10.8889 4.22222 10.8889M19.7778 10.8889V8.66667C19.7778 8.0773 19.5437 7.51207 19.1269 7.09532C18.7102 6.67857 18.1449 6.44444 17.5556 6.44444M4.22222 10.8889V8.66667C4.22222 8.0773 4.45635 7.51207 4.8731 7.09532C5.28984 6.67857 5.85507 6.44444 6.44444 6.44444M17.5556 6.44444V4.22222C17.5556 3.63285 17.3214 3.06762 16.9047 2.65087C16.4879 2.23413 15.9227 2 15.3333 2H8.66667C8.0773 2 7.51207 2.23413 7.09532 2.65087C6.67857 3.06762 6.44444 3.63285 6.44444 4.22222V6.44444M17.5556 6.44444H6.44444"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

DrawerIcon.displayName = 'DrawerIcon';
